import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { TextField, makeStyles } from "@material-ui/core";
import { selectCompany, set } from "./companySlice";

import { selectLanguage } from "../language/languageSlice";
import { selectScgbu } from "../scgbu/scgbuSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      "&:hover": {
        boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
      },
    },
  },
}));

export function Company() {
  const classes = useStyles();
  const language = useSelector(selectLanguage);
  const scgBu = useSelector(selectScgbu);
  const companyValue = useSelector(selectCompany);
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <form className={classes.root} noValidate autoComplete="on">
      <TextField
        required={scgBu !== "FC" ? true : false}
        id="input-companyName"
        label={
          language !== undefined
            ? language === "TH"
              ? "บริษัท"
              : "Company"
            : "Company"
        }
        placeholder={
          language !== undefined
            ? language === "TH"
              ? "ชื่อบริษัท"
              : "Company Name"
            : "Company Name"
        }
        variant="outlined"
        color="secondary"
        value={companyValue}
        multiline
        onChange={(e) => {
          if (e.target.value.length <= 100) {
            dispatch(set(e.target.value));
          }
        }}
      />{" "}
    </form>
  );
}
